import { Link } from "react-router-dom";

export const BrandLogo = ({ testId, onClick }) => <Link to="/" className="brand-logo" aria-label="Keepsake Books home" data-testid={testId} onClick={onClick}>
  <img src="/brand/keepsake-logo-horizontal-480.webp" srcSet="/brand/keepsake-logo-horizontal-480.webp 480w, /brand/keepsake-logo-horizontal-960.webp 960w" sizes="190px" width="480" height="121" alt="Keepsake Books"/>
</Link>;
